import { minLength, maxLength, stringPattern, stringPatternError, tagMinLength, tagMaxLength  } from '../../utils/form-validations';

export const gatewayDetailsDefault = { onto_manage_id: '', gateway_name: '', cidr_to_scan: '' };

export const gatewayDetailsUISchema = [
  { id: 1, label: 'Country', name: 'onto_manage_id', type: 'select', required: true },
  { id: 2, label: 'Display Name', name: 'gateway_name', type: 'input', required: true },
  { id: 3, label: 'CIDR(s) to Scan', name: 'cidr_to_scan', type: 'input', required: true },
];

export const gatewayDetailsSchema = {
  type: 'object',
  properties: {
    onto_manage_id: { type: 'number', minLength: 1, maxLength },
    gateway_name: {
      type: 'string',
      minLength,
      maxLength,
      pattern: stringPattern,
      errorMessage: {
        pattern: stringPatternError,
      },
    },
    cidr_to_scan: { minLength, maxLength },
  },
  required: ['onto_manage_id', 'gateway_name', 'cidr_to_scan'],
  additionalProperties: true,
};

export const gatewayMetaDataSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    key: {
      type: 'string',
      minLength : tagMinLength,
      maxLength: tagMaxLength,
      pattern: stringPattern,
      errorMessage: {
        pattern: stringPatternError,
      },
    },
    value: {
      type: 'string',
      minLength: tagMinLength,
      maxLength:tagMaxLength,
      pattern: stringPattern,
      errorMessage: {
        pattern: stringPatternError,
      },
    },
  },
  required: ['key', 'value'],
};
